module.exports = __webpack_public_path__ + "img/112234f.svg";